import { Heading, Primary } from '@cinch-labs/design-system'
import { CtaSection } from '../../types/store-hub'
import styles from './cta.module.css'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export interface CtaProps {
  cta: CtaSection
}

export const Cta = ({ cta }: CtaProps) => {
  const { title, body, ctaText } = cta
  const ctaCategory = 'happy to travel to any cinch store?'
  const { trackEvent } = useAnalytics()

  const allStoresPath = 'used-cars?store=all-stores'

  const handleClick = () => {
    trackEvent({
      eventName: `cinch stores hub - ${ctaCategory}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: 'select',
        event: {
          name: EventNames.click,
          category: ctaCategory,
          label: 'search all cinch store cars',
        },
      },
    })
    window.open(allStoresPath, '_blank')
  }

  return (
    <div className={styles.ctaWrapper}>
      <div className={styles.textWrapper}>
        <Heading element="h3">{title}</Heading>
        <p>{body}</p>
      </div>
      <Primary href={allStoresPath} onClick={() => handleClick()}>
        {ctaText}
      </Primary>
    </div>
  )
}
